//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
import verify_result_recommend from '@/common/mixins/verify_result_recommend'
import ExcellentConsultants from '@/components/business/_excellent_consultants'
import Item from './_item'
export default {
    mixins: [
        verify_result_recommend
    ],
    components: {
        Item,

        ExcellentConsultants
    },
    data () {
        return {
            fold_arr: [],
            is_level3: false,
            sqspf_url: "https://sqspf.cdzj.chengdu.gov.cn/advancedmanpurchaseapply"
        }
    },
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/pages/personal_package/qa/main')
        const option = {
            title: `${process.env.APP_NAME}-常见问题`,
            path: `/pages/index/main?sub_page=${sub_page}`
        }
        return this.getShareInfo(option)
    },
    mounted () {
        const { level } = this.$route.query
        this.is_level3 = Number(level) === 3
        if (this.is_level3) {
            this.getExcellentConsultant(true)
        }
    },
    methods: {
        handle (data) {
            WX_API.setClipboardData(data)
        },
        openJoinGroup () {
            wx.navigateTo({
                url: '/building/discuess_group/main'
            })
        }
    }
}
